import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface FeaturedArticleProps {
  title: string;
  excerpt: string;
  image: string;
  slug: string;
  author: string;
  date: string;
  category: string;
}

const FeaturedArticle = ({ title, excerpt, image, slug, author, date, category }: FeaturedArticleProps) => {
  const isSighting = slug.startsWith("__sighting__");
  const linkTo = isSighting ? `/sightings/${slug.replace("__sighting__", "")}` : `/blog/${slug}`;
  return (
    <Link to={linkTo} className="group block">
      <div className="relative overflow-hidden rounded-xl min-h-[500px] md:min-h-[600px]">
        <div className="absolute inset-0">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase px-3 py-1 bg-accent/90 text-accent-foreground rounded-full mb-4">
            {category}
          </span>
          <h2 className="text-3xl md:text-5xl font-bold leading-tight mb-4 text-foreground group-hover:text-accent transition-colors duration-300">
            {title}
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mb-6 leading-relaxed line-clamp-3">
            {excerpt}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-sm text-muted-foreground">{author}</span>
            <span className="text-muted-foreground">·</span>
            <span className="text-sm text-muted-foreground">{date}</span>
            <span className="ml-auto inline-flex items-center gap-1 text-accent text-sm font-medium group-hover:gap-2 transition-all">
              Read Article <ArrowRight className="w-4 h-4" />
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default FeaturedArticle;
